import type { CoreApiClient } from "../client";
import type { PostBuildingMeshesBody } from "../types";

export const createMeshMutations = (api: CoreApiClient) => {
  const { request } = api;

  const create = async (buildingId: string, body: PostBuildingMeshesBody) => {
    await request("post", "/buildings/{buildingId}/meshes", {
      params: { path: { buildingId } },
      body,
    });
  };

  return {
    create,
  };
};
